import { render, staticRenderFns } from "./TextAlignments.vue?vue&type=template&id=578530d6&"
import script from "./TextAlignments.vue?vue&type=script&lang=ts&"
export * from "./TextAlignments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports